import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Message from '../Message';
import { MessageType } from '../../common/Constants';
import UserResultTable from './UserResultTable';

const NoSearchFoundMessage = ({ t }) => (
  <Message id="zeroResultMessage" text={t('Search_returned_no_results.')} messageType={MessageType.notice} />
);

const InvalidWildCardSearchMessage = ({ t, invalidWildCardSearch }) => (
  <div id="invalidWildCardSearchMessage" className="email-change-history">
    {`${t('Displaying_search_results_for')} "*${invalidWildCardSearch.split('*')[1]}"`}
  </div>
);

const UsersListMessage = ({ t, current }) => (
  <div className="heading-highlight-gray text--benton-book margin-top-three margin-bottom-one">
    {current
      ? `${t('Current_user_with_this_email')}`
      : `${t('Users_that_were_previously_associated_with_this_email')}`}
  </div>
);

const UserResultView = (props) => {
  const {
    t, users, emailChangeHistory, invalidWildCardSearch, cannotSearchEmailChangeHistory,
  } = props;

  return (
    <div>
      {!emailChangeHistory && <UsersListMessage t={t} current />}
      {emailChangeHistory && <UsersListMessage t={t} current={false} />}
      {emailChangeHistory && cannotSearchEmailChangeHistory && (
        <Message
          id="cannotSearchEmailChangeHistory"
          text={t(
            "Couldn't perform search for this section.  Search word must include a domain name.  e.g., *@tableau.com",
          )}
          messageType={MessageType.notice}
        />
      )}
      {!cannotSearchEmailChangeHistory && invalidWildCardSearch.length > 0 && <InvalidWildCardSearchMessage t={t} invalidWildCardSearch={invalidWildCardSearch} />}
      {!cannotSearchEmailChangeHistory && users.length === 0 && <NoSearchFoundMessage t={t} />}
      {users.length > 0 && <UserResultTable users={users} />}
    </div>
  );
};

UserResultView.propTypes = {
  t: PropTypes.func.isRequired,
  users: PropTypes.array.isRequired,
  invalidWildCardSearch: PropTypes.string.isRequired,
  emailChangeHistory: PropTypes.bool.isRequired,
  cannotSearchEmailChangeHistory: PropTypes.bool.isRequired,
};

export default translate()(UserResultView);
